import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-checkbox-large",
  templateUrl: "./med-icon-checkbox-large.component.html",
})
export class MedIconCheckboxLargeComponent extends SvgMixinLargeComponent { }
